"use client"

import { motion } from "framer-motion"
import { GemIcon } from "lucide-react"

export default function CutEmeraldsHeader() {
  return (
    <motion.header
      className="bg-gradient-to-r from-emerald-900 via-teal-800 to-emerald-800 text-white py-10 px-6"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center gap-3">
          <motion.div
            whileHover={{ rotate: 360, scale: 1.1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            className="bg-emerald-800/30 p-3 rounded-full"
          >
            <GemIcon className="w-10 h-10 text-emerald-300" />
          </motion.div>
          <motion.h1
            className="text-4xl md:text-5xl font-serif tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-emerald-200 to-emerald-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Cut Emerald Collection
          </motion.h1>
        </div>

        <motion.p
          className="mt-4 text-emerald-100 max-w-3xl text-lg font-light text-center mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Explore our exquisite collection of expertly cut and polished emeralds that showcase the perfect balance of
          color, clarity, and brilliance. Each gem is a masterpiece of precision and artistry.
        </motion.p>
      </div>
    </motion.header>
  )
}
